export default __webpack_public_path__ + "static/media/challenges.29c4bc09.png";